export enum ConnectedAccountFundsStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Done = 'done',
    Failed = 'failed',
    Suspended = 'suspended',
    Blocked = 'blocked',
}
